module.exports = __webpack_public_path__ + "img/couples-061.94cab429.jpg";